import { Injectable } from '@angular/core';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private helperService: HelperService) {}

  // set(key: string, value: any) {
  //   const setValue = JSON.stringify(value);
  //   localStorage.setItem(key, setValue);
  // }

  // get(key: string) {
  //   let setValue;
  //   setValue = localStorage.getItem(key);
  //   if (setValue === 'undefined') {
  //     return setValue;
  //   }
  //   return typeof setValue === 'string' ? JSON.parse(setValue) : setValue;
  // }

  set(key: string, value: any) {
    const setValue = JSON.stringify(value);
    const encodedValue = btoa(encodeURIComponent(setValue));
    localStorage.setItem(key, encodedValue);
  }

  get(key: string) {
    const setValue = localStorage.getItem(key);
    if (setValue === null || setValue === 'undefined') {
      return setValue;
    }
    try {
      const decodedValue = decodeURIComponent(atob(setValue));
      return JSON.parse(decodedValue);
    } catch (e) {
      return setValue;
    }
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  getUser() {
    return this.get('user');
  }

  getUserId() {
    return this.get('user')?.userID;
  }

  // Clears the BVN entry plus any legacy plaintext 'userBvn' entries left
  // over from before BVN storage was encrypted.
  clearBvn() {
    localStorage.removeItem('bvn');
    localStorage.removeItem('userBvn');
    sessionStorage.removeItem('userBvn');
  }

  // Clear all user-related data (useful for logout)
  clearUserData() {
    this.remove('user');
    this.clearBvn();
    // Add any other user-related keys here
  }

  // Persist only the fields the app actually needs. Fields like birthDate,
  // gender, titleType, chargedBalance, qrTickets and socialSecurityNumber
  // are intentionally left out of storage.
  setUser(user: any): void {
    const { userID, name, family, emailAddress, mobileNumber } = user || {};
    this.set('user', { userID, name, family, emailAddress, mobileNumber });
  }

  // Get the user information from local storage
  // getUser(): any {
  //   return JSON.parse(localStorage.getItem('user') || '{}');
  // }

  // Encrypt and store the BVN, wiping any stale/legacy entries first
  setBvn(bvn: string): void {
    this.clearBvn();
    const encrypted = this.helperService.encryptBvn(bvn);
    if (typeof encrypted === 'string') {
      localStorage.setItem('bvn', encrypted);
    }
  }

  // Decrypt and return the stored BVN, discarding it if it can't be
  // decrypted to a valid 11-digit BVN (e.g. a leftover plaintext value
  // from before encryption was added).
  getBvn(): string | null {
    const stored = localStorage.getItem('bvn');
    if (!stored) {
      return null;
    }
    const decrypted = this.helperService.decryptBvn(stored);
    if (typeof decrypted === 'string' && /^\d{11}$/.test(decrypted)) {
      return decrypted;
    }
    localStorage.removeItem('bvn');
    return null;
  }
}
